import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageProvider";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeatureBanner from "./components/FeatureBanner";
import About from "./components/About";
import Programs from "./components/Programs";
import Gallery from "./components/Gallery";
import CampusLife from "./components/CampusLife";
import WhyUs from "./components/WhyUs";
import PlacementBanner from "./components/PlacementBanner";
import Footer from "./components/Footer";
import StickyCall from "./components/StickyCall";

const Home = () => {
  return (
    <div className="App relative bg-[#04060a] text-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <FeatureBanner />
        <About />
        <Programs />
        <Gallery />
        <CampusLife />
        <WhyUs />
        <PlacementBanner />
        <Footer />
      </main>
      <StickyCall />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
